export enum CustomerState {
  Active = 'Active',
  Inactive = 'Inactive'
}
